module.exports = __webpack_public_path__ + "img/pie-chart3.6bff7596.png";